import EvaluationSheet from '../components/EvaluationSheet/EvaluationSheet';

const EvaluationSheetPage = () => {
   return  <EvaluationSheet />;
};

export default EvaluationSheetPage;